import React from 'react';
import { useMediaPredicate } from 'react-media-hook';

import { media } from 'utilities/browser';

import ProductSortItemCallout from './ProductSortItemCallout';

type ProductSortItemCalloutsProps = { product: LP.product.ProductItem };

function ProductSortItemCallouts ({ product }: ProductSortItemCalloutsProps) {

	const isMediaDesktop = useMediaPredicate(media.DESKTOP);

	const { CalloutText } = product;
	let CalloutComponent: (() => any) | string = '';
	if (product.SoldOut) {

		CalloutComponent = () => (
			<ProductSortItemCallout styleVariant="soldOut">
				Sold
				<br />
				Out
			</ProductSortItemCallout>
		);

	}

	if (CalloutText && !product.IsDecrementable) {

		if (CalloutText.indexOf('16') > -1) {

			CalloutComponent = () => (
				<ProductSortItemCallout>
					<strong>16+</strong>
					{' '}
Colors
				</ProductSortItemCallout>
			);

		} else if (CalloutText.indexOf('100') > -1) {

			CalloutComponent = () => (
				<ProductSortItemCallout>
					<strong>100+</strong>
					{' '}
Colors
				</ProductSortItemCallout>
			);

		} else if (CalloutText.toLowerCase().indexOf('more') > -1 && isMediaDesktop) {

			CalloutComponent = () => <ProductSortItemCallout>More Options</ProductSortItemCallout>;

		}

	}

	if (product.IsDecrementable) {

		let AdjustedInventoryComponent: () => any = () => '';
		if (product.ShowInventory) {

			AdjustedInventoryComponent = () => (
				<ProductSortItemCallout>
					{product.AdjustedInventory}
					{' Left'}
				</ProductSortItemCallout>
			);

		}

		CalloutComponent = () => (
			<>
				<AdjustedInventoryComponent />
				<ProductSortItemCallout styleVariant="dailySale">
					Daily
					<br />
					Sale
				</ProductSortItemCallout>
			</>
		);

	}

	return (
		CalloutComponent !== '' && (
			<div className="ProductSortItemCallouts">
				<CalloutComponent />
			</div>
		)
	);

}

export default ProductSortItemCallouts;
